/* eslint-disable no-nested-ternary */
import format from "date-fns/format";
import { keyBy } from "lodash/fp";
import {
  ALL_DATES,
  INTEGER_KEYS,
  // AppliedFilterLabelMap,
  DATES,
  // DROPDOWN_KEYS,
  // DROPDOWN_REDUX_KEY_MAPPER,
  EXCLUDE_DATES,
  OS_DROPDOWN_KEYS,
} from "../../../contants";
import { ROUTES } from "../../../utils/constants";
import { isEmptyObj, isOSKey } from "../../../utils/helper";

const DATE_FORMAT = "yyyy-MM-dd";
const PLUS = "plus";
// const OS_LABEL = "organisationStructure";
export const POSITIONS_KEY = "dualPositionIds";
export const MAINLINE_POSITION_KEY = "mainlinePositionIds";
export const GOHONZON = "gohonzonTypes";
export const ROLE = "roleIds";

export const performOperation = (value, limit, operator = PLUS) =>
  operator === PLUS ? Number(value) + limit : Number(value) - limit;

export const getRoutePath = () => ROUTES.REPORTS_MEMBER.path;

// const handlePositions = (queryObject, currObj, key) => {
//   const dualPositions = currObj[POSITIONS_KEY] ?? [];

//   const keyValue = queryObject[key]
//     ? queryObject[key].split(",").map(Number)
//     : [];
//   return [...dualPositions, ...keyValue];
// };
// const handleMainlinePositions = (queryObject, currObj, key) => {
//   const currentPositions = currObj[MAINLINE_POSITION_KEY] ?? [];

//   const keyValue = queryObject[key]
//     ? queryObject[key].split(",").map(Number)
//     : [];
//   console.log(keyValue);
//   return [...currentPositions, ...keyValue];
// };

const handleOS = (queryObject, currObj, key) => {
  // const currentOS = currObj[OS_LABEL] ?? {};

  return Object.assign(currObj, {
    // [OS_LABEL]: { ...currentOS,
    [key]: Number(queryObject[key]),
  });
};
const DROPDOWN_REDUX_KEY_MAPPER = {
  areaId: "areas",
  clusterId: "clusters",
  zoneId: "zones",
  regionId: "regions",
  chapterId: "chapters",
  districtId: "districts",
  blockId: "blocks",
  city: "cities",
  state: "states",
  divisionId: "divisions",
  subDivisionId: "subDivisions",
  professionsId: "profession",
  specialGroupId: "specialGroups",
  periodDate: "attendanceDate",
  stateId: "states",
  cityId: "cities",
};
const AppliedFilterLabelMap = {
  id: "Member ID",
  fullName: "Member Name",
  roleId: "Role Id",
  roleName: "Role Name",
  mobileNumber: "Phone Number",
  emailId: "Email Id",
  address: "Address",
  pincode: "Pin Code",
  stateId: "State",
  cityId: "City",
  divisionId: "Division",
  subDivisionId: "Sub Division",
  specialGroupId: "Special Group",
  dateOfBirth: "Date of Birth",
  dateOfJoining: "Date of Joining",
  professionsId: "Profession",
  professionSpecialGroup: "Profession Special Group",
  appointmentFrom: "Appointment Date",
  // positions: "Positions",
  mainlinePositionIds: "Mainline Position",
  dualPositionIds: "Dual Position",
  roleIds: "Roles",
  subLeadershipPosition: "Subdivision Leadership Position",
  subDivisionAppointmentFrom: "Sub-Division Appointment Date",
  isGohonzon: "Gohonzon Member",
  conferralFrom: "Conferral Date",
  isOmamoriGohonzon: "Omamori Gohonzon",
  unsubscribe: "Unsubscribe (Wrong Email ID)",
  areaId: "Area",
  clusterId: "Cluster",
  zoneId: "Zone",
  regionId: "Region",
  chapterId: "Chapter",
  districtId: "District",
  blockId: "Block",
  application: "Application Date",
  allotment: "Allotment Date",
  conferred: "Conferred Date",
  appointedAt: "Appointment Date",
  conferralDate: "Conferral Date",
  gohonzonTypes: "Gohonzon Type",
  honoraryDistrictChief: "Honorary District Chief",
  specialGroupAppointments: "Special Group Appointments",
};
const DROPDOWN_KEYS = [
  "city",
  "state",
  "divisionId",
  "subDivisionId",
  "specialGroupId",
  "professionsId",
  "positionId",
  // "dualPositionIds",
  // "mainlinePositionIds",
  "stateId",
  "cityId",
  "roleId",
];

export const getFormattedQuery = (queryObject) =>
  !isEmptyObj(queryObject)
    ? Object.keys(queryObject).reduce((acc, currKey) => {
        let value = queryObject[currKey];
        // console.log(value);
        const key = currKey;

        if (INTEGER_KEYS.includes(currKey)) {
          value = Number(queryObject[currKey]);
        } else if (ALL_DATES.includes(currKey)) {
          value = format(new Date(queryObject[currKey]), DATE_FORMAT);
        } else if (OS_DROPDOWN_KEYS.includes(currKey)) {
          return handleOS(queryObject, acc, currKey);
        }
        return Object.assign(acc, {
          [key]: value,
        });
      }, {})
    : {};

export const getFilters = (queryObject, metaData, disabledOSKeys) => {
  const INTERNAL_KEYS = ["timestamp"]; // 🔧 Add internal keys to ignore

  return Object.keys(queryObject).reduce((acc, curr) => {
    if (INTERNAL_KEYS.includes(curr) || EXCLUDE_DATES.includes(curr)) {
      return acc; // ⛔ skip timestamp and excluded date keys
    }

    // ⏳ Handle dates
    if (DATES.includes(curr)) {
      const key = curr.split("From")[0];
      acc.push({
        key: curr,
        displayName: AppliedFilterLabelMap[key],
        value: `${queryObject[curr]} - ${queryObject[`${key}To`]}`,
        disabled:
          Array.isArray(disabledOSKeys) && disabledOSKeys.includes(curr),
      });
      return acc;
    }

    // 🧘‍♂️ Handle Gohonzon
    if (GOHONZON.includes(curr)) {
      acc.push({
        key: curr,
        displayName: AppliedFilterLabelMap[curr],
        value: queryObject[curr].replace(/_/g, " "),
        disabled:
          Array.isArray(disabledOSKeys) && disabledOSKeys.includes(curr),
      });
      return acc;
    }

    // ⬇️ Handle dropdowns
    if (DROPDOWN_KEYS.includes(curr) || OS_DROPDOWN_KEYS.includes(curr)) {
      const pool = isOSKey(curr)
        ? metaData.organisationStructure[DROPDOWN_REDUX_KEY_MAPPER[curr]]
        : metaData[DROPDOWN_REDUX_KEY_MAPPER[curr]];

      const selectedValue = pool.find(
        (p) =>
          (p.structureId ||
            p.divisionId ||
            p.cityId ||
            p.stateId ||
            p.positionId ||
            p.professionsId ||
            p.roleId ||
            p.specialGroupId) === Number(queryObject[curr])
      );

      acc.push({
        key: curr,
        displayName: AppliedFilterLabelMap[curr],
        value:
          selectedValue?.name ||
          selectedValue?.cityName ||
          selectedValue?.stateName ||
          selectedValue?.profession ||
          queryObject[curr],
        disabled:
          Array.isArray(disabledOSKeys) && disabledOSKeys.includes(curr),
      });
      return acc;
    }

    // 🧩 Dual Positions
    if (curr === POSITIONS_KEY) {
      const positionsMap = keyBy("value", metaData.dualPositionIds);
      const inputPositions = queryObject[curr].split(",");
      const positionsLabel = inputPositions.map(
        (pos) => positionsMap[pos]?.entityTitle
      );
      acc.push({
        key: curr,
        displayName: "Positions",
        value: positionsLabel.join(", "),
      });
      return acc;
    }

    // 🔵 Mainline Positions
    if (curr === MAINLINE_POSITION_KEY) {
      const positionsMap = keyBy("value", metaData.mainlinePositionIds);
      const inputPositions = queryObject[curr].split(",");
      const positionsLabel = inputPositions.map(
        (pos) => positionsMap[pos]?.entityTitle
      );
      acc.push({
        key: curr,
        displayName: "Mainline Positions",
        value: positionsLabel.join(", "),
      });
      return acc;
    }

    // 🧑‍💼 Roles
    if (curr === ROLE) {
      const positionsMap = keyBy("value", metaData.roleIds);
      const inputPositions = queryObject[curr].split(",");
      const positionsLabel = inputPositions.map(
        (pos) => positionsMap[pos]?.entityTitle
      );
      acc.push({
        key: curr,
        // displayName: "Roles",
        displayName: "Statistics Incharges",
        value: positionsLabel.join(", "),
      });
      return acc;
    }

    // 🧾 All others
    acc.push({
      key: curr,
      displayName: AppliedFilterLabelMap[curr],
      value: queryObject[curr],
      disabled: Array.isArray(disabledOSKeys) && disabledOSKeys.includes(curr),
    });

    return acc;
  }, []);
};

export const handleDependencyFilter = (query) => {
  const updatedQueryWithOS = { ...query };
  if (!updatedQueryWithOS?.areaId) {
    delete updatedQueryWithOS.clusterId;
    delete updatedQueryWithOS.zoneId;
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.clusterId) {
    delete updatedQueryWithOS.zoneId;
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.zoneId) {
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.regionId) {
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.chapterId) {
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.districtId) {
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  }

  // state and divisions
  if (!updatedQueryWithOS?.state) {
    delete updatedQueryWithOS.city;
  }
  if (!updatedQueryWithOS?.divisionId) {
    delete updatedQueryWithOS.subDivisionId;
    delete updatedQueryWithOS.specialGroupId;
  }
  if (!updatedQueryWithOS?.honoraryDistrictChief) {
    delete updatedQueryWithOS.honoraryDistrictChief;
  }

  return updatedQueryWithOS;
};
